export const STATUS_COLORS = {
    Pending: { bg: "bg-amber-100", text: "text-amber-800", ring: "ring-amber-400" },
    Confirmed: { bg: "bg-blue-100", text: "text-blue-800", ring: "ring-blue-400" },
    "Out for Delivery": { bg: "bg-indigo-100", text: "text-indigo-800", ring: "ring-indigo-500" },
    Delivered: { bg: "bg-emerald-100", text: "text-emerald-800", ring: "ring-emerald-500" },
    Cancelled: { bg: "bg-red-100", text: "text-red-800", ring: "ring-red-400" },
};

export const STATUS_ORDER = ["Pending", "Confirmed", "Out for Delivery", "Delivered", "Cancelled"];
